import React, { useState } from 'react';
import { Modal, Button, Card, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

interface UpgradeModalProps {
  show: boolean;
  onHide: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleUpgrade = async (priceType: 'monthly' | 'annual') => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${API_BASE_URL}/billing/create-checkout-session`, {
        priceType
      });

      // Redirect to Stripe Checkout
      window.location.href = response.data.url;
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to start checkout. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upgrade to Pro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="text-muted mb-4">
          {/*Unlock unlimited projects and more photos per case study.*/}
        </p>

        <div className="d-flex gap-3 justify-content-center flex-wrap">
          {/* Monthly Plan */}
          <Card style={{ width: '220px' }} className="text-center">
            <Card.Header className="bg-light">
              <h5 className="mb-0">Monthly</h5>
              <small>Quickstart</small>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <span className="display-5 fw-bold">$9</span>
                <span className="text-muted">/month</span>
              </div>
              <ul className="list-unstyled text-start small mb-3">
                <li>Up to 800 case studies</li>
                <li>10 photos per project</li>
                <li>Custom branding</li>
                <li>Priority support</li>
              </ul>
              <Button
                variant="outline-primary"
                className="w-100"
                onClick={() => handleUpgrade('monthly')}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" /> : 'Choose Monthly'}
              </Button>
            </Card.Body>
          </Card>

          {/* Annual Plan */}
          <Card style={{ width: '220px' }} className="text-center border-primary">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Annual</h5>
              <small>Save $18!</small>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <span className="display-5 fw-bold">$90</span>
                <span className="text-muted">/year</span>
              </div>
              <ul className="list-unstyled text-start small mb-3">
                <li>Up to 800 case studies</li>
                <li>10 photos per project</li>
                <li>Custom branding</li>
                <li>Priority support</li>
              </ul>
              <Button
                variant="primary"
                className="w-100"
                onClick={() => handleUpgrade('annual')}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" /> : 'Choose Annual'}
              </Button>
            </Card.Body>
          </Card>
        </div>

        <div className="text-center mt-4">
          <small className="text-muted">
            Secure payment via Stripe. Cancel anytime.
          </small>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeModal;
